import { Observable, Subscription } from 'rxjs';

import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { MatSelectChange } from '@angular/material/select';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';

import { AppConst } from '../../app-const';
import { EntranceExitEntry } from '../../firestore-models/entrance-exit-entry';
import { EntranceExitEvent } from '../../firestore-models/entrance-exit-event';
import { Exhibit } from '../../firestore-models/exhibit';
import { EntranceExitTransit } from '../../firestore-models/entrance-exit-transit';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';


export interface EntranceExitEntryDialogData {
  entry?: EntranceExitEntry | null;
  event?: EntranceExitEvent | null;
  exhibits?: Exhibit[] | null;  
}

@Component({
  selector: 'app-entrance-exit-transit-dialog',
  templateUrl: './entrance-exit-transit-dialog.component.html',
  styleUrls: ['./entrance-exit-transit-dialog.component.css'],
  standalone: false,
})
export class EntranceExitTransitDialogComponent implements OnInit {

  //入退場管理エントリー情報
  entry!: EntranceExitEntry;

  projectId: string;

  projectLanguages!: Array<ProjectLanguage>;


  private transitsCollection!: AngularFirestoreCollection<EntranceExitTransit>;
  transitsObservable!: Observable<EntranceExitTransit[]>;
  transitsSubscribe!: Subscription;
  allTransits!: Array<EntranceExitTransit>;
  transits!: Array<EntranceExitTransit>;
  event!: EntranceExitEvent;
  exhibits!: Exhibit[];
  dates: string[] = [];

  gateTypeEntrance = AppConst.ENTRANCE_EXIT_GATE_TYPE_ENTRANCE;
  gateTypeExit = AppConst.ENTRANCE_EXIT_GATE_TYPE_EXIT;
  gateTypeExhibit = AppConst.ENTRANCE_EXIT_GATE_TYPE_EXHIBIT;

  //入退場管理入退場状況フォーム
  viewForm: FormGroup;
  dateControl!: FormControl;

  constructor(
    public dialogRef: MatDialogRef<EntranceExitTransitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EntranceExitEntryDialogData,
    public dialog: MatDialog,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
    this.viewForm = this.formBuilder.group(
    {
      date: ['', []],
    });
    this.dateControl = this.viewForm.get('date') as FormControl;
   }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.entry = this.data.entry!;
    if (this.data.event) {
      this.event = this.data.event;
    }
    this.transits = [];
    this.exhibits = this.data.exhibits!;
    this.transitsCollection = this.angularFirestore.collection<EntranceExitTransit>(
      AppConst.FIRESTORE_ENTRANCE_EXIT_TRANSITS, ref => ref.where('project_id', '==', this.projectId).where('entrance_exit_event_id', '==', this.entry?.entrance_exit_event_id).where('entry_no', '==', this.entry?.entry_no).where('preview', '==', this.entry?.preview));
    this.transitsObservable = this.transitsCollection.valueChanges({ idField: 'id' });
    this.transitsSubscribe = this.transitsObservable.subscribe(transits => {
      this.allTransits = transits.sort((a, b) => {
        if (a.date < b.date) {
          return 1;
        } else if (a.date > b.date) {
          return -1;
        } else {
          return a.created.seconds < b.created.seconds ? 1 : -1
        }
      });
      this.dates = [];
      let date = '';
      for (const transit of this.allTransits) {
        if (date !== transit.date) {
          date = transit.date;
          this.dates.push(date);
        }
      }
      if (this.dates.length > 0 && !this.dateControl.value) {
        this.transits = this.allTransits.filter(transit => transit.date === this.dates[0]);
        this.dateControl.setValue(this.dates[0]);
      }
    });    
  }

  changeDate(event: any) {
    this.transits = this.allTransits.filter(transit => transit.date === event);
  }
 
  onNoClick(): void {
    this.dialogRef.close();
  }

  getTransits(type: number): any[] {
    let transits = this.transits.filter(transit => transit.gate_type === type);

    transits = transits.sort((a, b) => {
      if (a.entrance_exit_id < b.entrance_exit_id) {
        return 1;
      } else {
        return -1;
      }
    });

    let count = 0;
    let entranceExitId = null
    let updated = null
    let countedTransits = [];

    for (const transit of transits) {
      if (!entranceExitId || !updated) {
        entranceExitId = transit.entrance_exit_id;
        updated = transit.created;
        count = 1;
      } else if (entranceExitId !== transit.entrance_exit_id) {
        countedTransits.push({entrance_exit_id: entranceExitId, count: count, updated: updated});
        entranceExitId = transit.entrance_exit_id;
        updated = transit.created;
        count = 1;
      } else {
        updated = transit.created;
        count++;    
      }
    }

    if (!!entranceExitId) {
      countedTransits.push({entrance_exit_id: entranceExitId, count: count, updated: updated});
    }
    return countedTransits;
  }

}
